import { z } from 'zod';

export const Phone = z.object({
  countryCode: z.string().nonempty("Please select country code"),
  phoneNumber: z.string().nonempty("Please enter valid phone number"),
})